import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RouterHelperService } from 'src/app/core/services/router-helper/router-helper.service';
import { AnalyticsService } from '@core/services/app/analytics.service';

@Component({
  selector: 'app-redirect-page',
  template: ``,
})
export class RedirectPageComponent implements OnInit {
  @Input() redirectTo?: string;

  constructor(
    private readonly router: Router,
    private readonly routerHelper: RouterHelperService,
    private readonly analyticsService: AnalyticsService,
  ) {}

  ngOnInit(): void {
    if (!this.redirectTo) {
      this.redirectTo = '/';
    }

    if (this.redirectTo.startsWith('/')) {
      this.analyticsService.log({
        level: 'debug',
        label: '#DOOD-1250 Navigate',
        message: {
          from: 'RedirectPageComponent Ligne°24',
          target: [this.routerHelper.translateRoute(this.redirectTo)],
          currentLocation: window.location.pathname,
        },
      });
      this.router.navigate([this.routerHelper.translateRoute(this.redirectTo)]);
    } else {
      this.analyticsService.log({
        level: 'debug',
        label: '#DOOD-1250 Navigate',
        message: {
          from: 'RedirectPageComponent Ligne°36',
          target: this.redirectTo,
          currentLocation: window.location.pathname,
        },
      });
      window.location.href = this.redirectTo;
    }
  }
}
